import { ObjectiveType } from '@/features/actions/logic/types'

export type SuccessViewObjectiveType = ObjectiveType

export const objectiveTypeToVerb: Record<SuccessViewObjectiveType, string> = {
  deposit: 'Deposited',
  borrow: 'Borrowed',
  withdraw: 'Withdrew',
  repay: 'Repaid',
  setUseAsCollateral: 'Set',
  setUserEMode: 'Set',
  claimMarketRewards: 'Claimed',
  bridgeToHyperEVM: 'Bridged',
  bridgeToHyperCore: 'Bridged',
  isolatedWithdraw: 'Withdrew',
  isolatedLendWithdraw: 'Withdrew',
  isolatedLendDeposit: 'Supplied',
  isolatedDeposit: 'Deposited',
  isolatedBorrow: 'Borrowed',
  isolatedRepay: 'Repaid',
  vaultDeposit: 'Deposited',
  vaultWithdraw: 'Withdrew',
  wrap: 'Wrapped',
  permit2Sign: 'Signed permit',
}
